/**
 * Amazon マーケットプレイス関連の表示ユーティリティ。
 */

// Marketplace IDからマーケットプレイス名を取得
export function getMarketplaceName(marketplaceId?: string): string {
  if (!marketplaceId) return '日本';

  const nameMap: Record<string, string> = {
    'A1VC38T7YXB528': '日本',
    'ATVPDKIKX0DER': 'アメリカ',
    'A2EUQ1WTGCTBG2': 'カナダ',
    'A1AM78C64UM0Y8': 'メキシコ',
    'A2Q3Y263D00KWC': 'ブラジル',
    'A1F83G8C2ARO7P': 'イギリス',
    'A1PA6795UKMFR9': 'ドイツ',
    'A13V1IB3VIYZZH': 'フランス',
    'APJ6JRA9NG5V4': 'イタリア',
    'A1RKKUPIHCS9HS': 'スペイン',
    'A1805IZSGTT6HS': 'オランダ',
    'A39IBJ37TRP1C6': 'オーストラリア',
    'A19VAU5U5O7RUS': 'シンガポール',
  };

  return nameMap[marketplaceId] || marketplaceId;
}

// Marketplace IDから適切なAmazonドメインを取得
export function getAmazonDomain(marketplaceId?: string): string {
  if (!marketplaceId) return 'amazon.co.jp';

  const domainMap: Record<string, string> = {
    'A1VC38T7YXB528': 'amazon.co.jp',      // JP
    'ATVPDKIKX0DER': 'amazon.com',         // US
    'A2EUQ1WTGCTBG2': 'amazon.ca',         // CA
    'A1AM78C64UM0Y8': 'amazon.com.mx',     // MX
    'A2Q3Y263D00KWC': 'amazon.com.br',     // BR
    'A1F83G8C2ARO7P': 'amazon.co.uk',      // UK
    'A1PA6795UKMFR9': 'amazon.de',         // DE
    'A13V1IB3VIYZZH': 'amazon.fr',         // FR
    'APJ6JRA9NG5V4': 'amazon.it',          // IT
    'A1RKKUPIHCS9HS': 'amazon.es',         // ES
    'A1805IZSGTT6HS': 'amazon.nl',         // NL
    'A39IBJ37TRP1C6': 'amazon.com.au',     // AU
    'A19VAU5U5O7RUS': 'amazon.sg',         // SG
  };

  return domainMap[marketplaceId] || 'amazon.co.jp';
}

// Marketplace IDから適切なSeller Centralドメインを取得
export function getSellerCentralDomain(marketplaceId?: string): string {
  if (!marketplaceId) return 'sellercentral.amazon.co.jp';

  const domainMap: Record<string, string> = {
    'A1VC38T7YXB528': 'sellercentral.amazon.co.jp',           // JP
    'ATVPDKIKX0DER': 'sellercentral.amazon.com',              // US
    'A2EUQ1WTGCTBG2': 'sellercentral.amazon.ca',              // CA
    'A1AM78C64UM0Y8': 'sellercentral.amazon.com.mx',          // MX
    'A2Q3Y263D00KWC': 'sellercentral.amazon.com.br',          // BR
    'A1F83G8C2ARO7P': 'sellercentral-europe.amazon.com',      // UK (EU)
    'A1PA6795UKMFR9': 'sellercentral-europe.amazon.com',      // DE (EU)
    'A13V1IB3VIYZZH': 'sellercentral-europe.amazon.com',      // FR (EU)
    'APJ6JRA9NG5V4': 'sellercentral-europe.amazon.com',       // IT (EU)
    'A1RKKUPIHCS9HS': 'sellercentral-europe.amazon.com',      // ES (EU)
    'A1805IZSGTT6HS': 'sellercentral-europe.amazon.com',      // NL (EU)
    'A39IBJ37TRP1C6': 'sellercentral.amazon.com.au',          // AU
    'A19VAU5U5O7RUS': 'sellercentral.amazon.sg',              // SG
  };

  return domainMap[marketplaceId] || 'sellercentral.amazon.co.jp';
}

// 寸法をフォーマット
export function formatDimensions(dimensions?: { height?: { value: number; unit: string }; width?: { value: number; unit: string }; length?: { value: number; unit: string } }): string {
  if (!dimensions) return '';

  const parts: string[] = [];
  if (dimensions.width?.value != null && dimensions.width?.unit) {
    parts.push(`幅${dimensions.width.value}${dimensions.width.unit}`);
  }
  if (dimensions.height?.value != null && dimensions.height?.unit) {
    parts.push(`高さ${dimensions.height.value}${dimensions.height.unit}`);
  }
  if (dimensions.length?.value != null && dimensions.length?.unit) {
    parts.push(`奥行き${dimensions.length.value}${dimensions.length.unit}`);
  }

  return parts.join(' x ');
}

// 価格をフォーマット
export function formatPrice(amount?: number, currency?: string): string {
  if (!amount) return '';

  if (currency === 'JPY') {
    return `¥${amount.toLocaleString()}`;
  }

  return `${currency} ${amount.toLocaleString()}`;
}
